// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3mW4S","title":"ClientCherryInfo_title__3XX2x","itemText":"ClientCherryInfo_itemText__1Y5gB"};